<div class="bg-container mat-typography">
  <mat-icon class="logo" [svgIcon]="'tepra-logo'"></mat-icon>

  <div class="page-content">
    <div
      fxLayout="column"
      fxFlexAlign="center"
      class="fields-container-width primary-font expired-container"
      ngClass.gt-md="lg"
      ngClass.md="md"
      ngClass.sm="sm"
      ngClass.xs="xs"
    >
      <div class="expired-message">
        <mat-icon class="icon-size">cancel</mat-icon>
        <h2 class="primary-font title">{{ 'auth.expiredMsg' | translate }}</h2>
      </div>
    </div>
  </div>
</div>
